function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Docker Moby logo");

var SvgDocker = function SvgDocker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 238.5 135.17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M530.68,487h21.39v21.86h10.7a46,46,0,0,0,14.85-2.55,48.55,48.55,0,0,0,7.34-3.19,27.26,27.26,0,0,1-5.11-13.88c-.64-6.7.8-15.32,5.27-20.59l2.24-2.55,2.71,2.08c6.7,5.43,12.45,13.09,13.41,21.7,8.15-2.39,17.72-1.92,24.75,2.23l3,1.76-1.6,3c-6.06,11.81-18.66,15.48-31.12,14.84-18.52,46-58.75,67.83-107.6,67.83-25.22,0-48.53-9.42-61.62-31.76l-.32-.48-1.92-3.83a60.54,60.54,0,0,1-4.79-31.44l.16-3.19H440.8V487H462.2V465.64H505V444.41h25.7Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#384d54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,495h0c1.44-11-7-19.79-12.13-23.94-5.91,6.86-6.87,24.9,2.39,32.56-5.11,4.63-16.12,8.78-27.46,8.78h-137a57.88,57.88,0,0,0,5.59,31.76L433,547a52.7,52.7,0,0,0,3.19,4.95c5.75.32,10.86.48,15.65.32,9.26-.16,16.92-1.28,22.67-3.35a1.51,1.51,0,0,1,2.08,1.12,1.54,1.54,0,0,1-1,2.08,14,14,0,0,0-2.4.8,78.06,78.06,0,0,1-15.65,2.55h-1.12c-2.55.16-5.11.16-8,.16s-5.91,0-9.1-.16h-.16c11.49,12.93,29.37,20.59,51.72,20.59,47.26,0,87.49-21.07,105.37-68.15,12.61,1.28,24.74-1.92,30.17-12.61C617.7,490.22,606.36,491.81,600,495Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#00a8d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,495h0c1.44-11-7-19.79-12.13-23.94-5.91,6.86-6.87,24.9,2.39,32.56-5.11,4.63-16.12,8.78-27.46,8.78H433.94c-.64,18,6.07,31.6,17.88,39.9,9.26-.16,16.92-1.28,22.67-3.35a1.51,1.51,0,0,1,2.08,1.12,1.54,1.54,0,0,1-1,2.08,14,14,0,0,0-2.4.8,72.69,72.69,0,0,1-16.12,2.55l-.16-.16c16.12,8.3,39.43,8.3,66.25-2.08,30.17-11.49,58.11-33.51,77.59-58.57A2.7,2.7,0,0,1,600,495Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#29b8eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,526.6h0a56.44,56.44,0,0,0,5.43,17.56L433,547a52.7,52.7,0,0,0,3.19,4.95c5.75.32,10.86.48,15.65.32,9.26-.16,16.92-1.28,22.67-3.35a1.51,1.51,0,0,1,2.08,1.12,1.54,1.54,0,0,1-1,2.08,14,14,0,0,0-2.4.8,71.16,71.16,0,0,1-16.12,2.55h-.8c-2.39.16-5.11.16-7.82.16-3,0-6.07,0-9.42-.16,11.49,12.77,29.53,20.59,51.88,20.59,40.55,0,75.83-15.48,96.27-49.47Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#038ab8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.06,526.6h0a40.89,40.89,0,0,0,16.76,25.69c9.26-.16,16.92-1.28,22.67-3.35a1.51,1.51,0,0,1,2.08,1.12,1.54,1.54,0,0,1-1,2.08,14,14,0,0,0-2.4.8,72.7,72.7,0,0,1-16.28,2.55c16.12,8.3,39.43,8.14,66.25-2.23A171.87,171.87,0,0,0,569,526.6Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#0099c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.32,490.53h18.52V509H444.32Zm1.6,1.6h1.44v15.32h-1.44Zm2.72,0h1.6v15.32h-1.6Zm2.87,0h1.44v15.32H451.5Zm2.72,0h1.6v15.32h-1.6Zm2.87,0h1.44v15.32h-1.44Zm2.72,0h1.6v15.32h-1.6Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#00abd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.71,469.15h18.52v18.51H465.71Zm1.6,1.6h1.44v15.48H467.3Zm2.72,0h1.6v15.48H470Zm2.87,0h1.44v15.48h-1.44Zm2.72,0h1.6v15.48h-1.6Zm2.87,0h1.44v15.48h-1.44Zm2.72,0h1.6v15.48h-1.6Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#00abd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.71,490.53h18.52V509H465.71Zm1.6,1.6h1.44v15.32H467.3Zm2.72,0h1.6v15.32H470Zm2.87,0h1.44v15.32h-1.44Zm2.72,0h1.6v15.32h-1.6Zm2.87,0h1.44v15.32h-1.44Zm2.72,0h1.6v15.32h-1.6Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#21c2ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.1,490.53h18.52V509H487.1Zm1.6,1.6h1.44v15.32H488.7Zm2.72,0H493v15.32h-1.6Zm2.87,0h1.44v15.32h-1.44Zm2.72,0h1.6v15.32H497Zm2.87,0h1.44v15.32h-1.44Zm2.72,0h1.6v15.32h-1.6Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#00abd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.1,469.15h18.52v18.51H487.1Zm1.6,1.6h1.44v15.48H488.7Zm2.72,0H493v15.48h-1.6Zm2.87,0h1.44v15.48h-1.44Zm2.72,0h1.6v15.48H497Zm2.87,0h1.44v15.48h-1.44Zm2.72,0h1.6v15.48h-1.6Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#21c2ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.49,490.53H527V509H508.49Zm1.6,1.6h1.44v15.32h-1.44Zm2.72,0h1.6v15.32h-1.6Zm2.87,0h1.44v15.32h-1.44Zm2.72,0H520v15.32h-1.6Zm2.87,0h1.44v15.32h-1.44Zm2.72,0h1.6v15.32H524Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#21c2ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.49,469.15H527v18.51H508.49Zm1.6,1.6h1.44v15.48h-1.44Zm2.72,0h1.6v15.48h-1.6Zm2.87,0h1.44v15.48h-1.44Zm2.72,0H520v15.48h-1.6Zm2.87,0h1.44v15.48h-1.44Zm2.72,0h1.6v15.48H524Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#00abd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.49,447.76H527v18.51H508.49Zm1.6,1.6h1.44v15.48h-1.44Zm2.72,0h1.6v15.48h-1.6Zm2.87,0h1.44v15.48h-1.44Zm2.72,0H520v15.48h-1.6Zm2.87,0h1.44v15.48h-1.44Zm2.72,0h1.6v15.48H524Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#21c2ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.89,490.53H548.4V509H529.89Zm1.6,1.6h1.44v15.32h-1.44Zm2.72,0h1.44v15.32H534.2Zm2.87,0h1.44v15.32h-1.44Zm2.72,0h1.6v15.32h-1.6Zm2.87,0h1.44v15.32h-1.44Zm2.72,0h1.44v15.32h-1.44Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#00abd1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.11,539.05h0a5.14,5.14,0,0,1,5.11,5.11,5.11,5.11,0,0,1-10.22,0A5.14,5.14,0,0,1,483.11,539.05Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#d4edf0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.11,540.49h0a3,3,0,0,1,1.28.32,2,2,0,0,0-.64,1.28,1.57,1.57,0,0,0,1.44,1.59,1.26,1.26,0,0,0,1.28-.8,3,3,0,0,1,.32,1.28,3.67,3.67,0,0,1-7.35,0A3.71,3.71,0,0,1,483.11,540.49Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#384d54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.75,528.52H630.46c-5.11-1.28-16.28-3-14.53-9.9-9.4,10.85-32.08,7.66-37.83,2.23-6.39,9.26-43.58,5.74-46.14-1.44-8,9.42-32.73,9.42-40.71,0-2.71,7.18-39.75,10.69-46.14,1.44-5.75,5.43-28.42,8.62-37.84-2.23C409,525.49,397.86,527.24,392.75,528.52Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#384d54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.68,575.92h0c-12.61-5.91-19.64-14.2-23.47-23a90.54,90.54,0,0,1-16.92,2.55c-2.39,0-5.11.16-7.82.16-3.19,0-6.39-.16-9.9-.32,11.65,11.65,25.86,20.59,52.36,20.75C492.85,576.08,494.76,576.08,496.68,575.92Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#bfdbe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478,561.07h0a51.86,51.86,0,0,1-4.79-8.14,90.54,90.54,0,0,1-16.92,2.55C460.76,557.88,467.3,560.12,478,561.07Z",
    transform: "translate(-392.75 -444.41)",
    style: {
      fill: "#d4edf0"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/docker.2f787eb6.svg";
export { ForwardRef as ReactComponent };